import { CORE_SECTTION_SCORES } from "../config";
import { ResumeAnalysis } from "../resume-analysis/resume-analyse-types";
import { EducationScoreAnalysis } from "../types";


// college: 0.35,
// marks: 0.2,
// degree: 0.2,
// graduationYear: 0.15,
// reverseOrder: 0.1


export const getEducationScore = (educations: ResumeAnalysis["educations"], maxScoreOfSection: number): EducationScoreAnalysis => {
  if (educations.individualEducationsAnalysis.length === 0) {
    return {
      totalScore: 0,
      informationMistakeCount: 0,
      totalMistakeCount: 0
    };
  }

  let informationMistakeCount = 0;
  let totalMistakeCount = 0;


  educations.individualEducationsAnalysis.forEach((edu) => {
    if (!edu.school) {
      informationMistakeCount++;
    }
    if (!edu.gpa) {
      informationMistakeCount++;
    }
    if (!edu.degree) {
      informationMistakeCount++;
    }
    if (!edu.startDate && !edu.endDate) {
      informationMistakeCount++;
    }
  }
  );
  totalMistakeCount = informationMistakeCount;

  let totalScore = maxScoreOfSection;
  if (totalMistakeCount > 0 && totalMistakeCount <= 3) {
    totalScore -= 0.1 * maxScoreOfSection;
  } else if (totalMistakeCount > 3 && totalMistakeCount <= 6) {
    totalScore -= 0.25 * maxScoreOfSection;
  } else if (totalMistakeCount > 6 && totalMistakeCount <= 12) {
    totalScore -= 0.4 * maxScoreOfSection;
  } else if (totalMistakeCount > 12 && totalMistakeCount <= 18) {
    totalScore -= 0.6 * maxScoreOfSection;
  } else if (totalMistakeCount > 18) {
    totalScore -= 0.8 * maxScoreOfSection;
  }
  return {
    totalScore: Math.min(totalScore, maxScoreOfSection),
    informationMistakeCount,
    totalMistakeCount
  }

}
